import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useTheme} from '@mui/material'

const TableButton = ({ children, color, icon, onClick }) => {

  const theme = useTheme()
  return (
    <Button
      variant="outlined"
      size="small"
      color={color}
      startIcon={icon}
      onClick={onClick}
      sx={{
        borderRadius: '0.8rem',
        borderColor: theme.vars.palette.buttonBorder,
        color: theme.vars.palette.text.primary,
        padding: "0.8rem 1.6rem"
      }}
    >
      <Typography variant="button">{children}</Typography>
    </Button>
  )
}

export default TableButton
